import React from 'react';
import CurrencyInput from 'react-currency-input-field';
import { PriceLayoutProps } from 'ui-builder';
import { cn } from 'shadcn-ui';
import ShadcnBaseInputLayout from '../../layout/ShadcnBaseInputLayout';

function ShadcnPriceLayout(props: PriceLayoutProps) {
  return (
    <ShadcnBaseInputLayout
      name={props.name}
      label={props.label}
      errors={props.errors}
      hideLabel
    >
      <div className="relative">
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-gray-400 pointer-events-none">
          $
        </span>
        <CurrencyInput
          onValueChange={(value) => {
            props.onChangeCallback({
              target: {
                value: value ?? null,
              },
            });
          }}
          placeholder={props.placeholder}
          value={props.value || undefined}
          allowDecimals={false}
          decimalSeparator="."
          disableAbbreviations
          className={cn(
            '!h-9 w-full min-w-0 !rounded-full !border !border-gray-200 !bg-gray-100 !pl-7 !pr-3 !py-2 !text-sm !text-gray-700 !shadow-none transition-[color,box-shadow,border-color] !outline-none !placeholder:text-input-placeholder disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 !mb-0',
            'focus-visible:!border-blue-500 focus-visible:!ring-0',
            'aria-invalid:!border-rose-600 aria-invalid:!ring-0',
          )}
        />
      </div>
    </ShadcnBaseInputLayout>
  );
}

export default ShadcnPriceLayout;
